import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'invoice-cell',
    template: `<span><i class="fa fa-clipboard" (click)="invokeParentMethod();" style="width:100%;"></i></span>`,
    styles: [
        `.btn {
      line-height: 0.5
    }`
    ]
})

export class InvoiceChildRendered implements ICellRendererAngularComp {
    public params: any;

    agInit(params: any): void {
        this.params = params;
    }

    public invokeParentMethod() {
        this.params.context.invoiceCell(this.params);
    }

    refresh(): boolean {
        return false;
    }
}
